"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileViewerRenderer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = _interopRequireDefault(require("britive-design-system/core/components/button"));

var _fileViewer = _interopRequireDefault(require("britive-design-system/core/components/file-viewer"));

var _spinner = _interopRequireDefault(require("britive-design-system/core/components/spinner"));

var _notification = _interopRequireDefault(require("britive-design-system/core/components/notification"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _IoReload = _interopRequireDefault(require("../../assets/IoReload.svg"));

var _commonUtils = require("../../utils/common-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FileViewerRenderer = function FileViewerRenderer(_ref) {
  var file = _ref.file,
      fileName = _ref.fileName,
      fileFieldName = _ref.fileFieldName,
      secretFileDownloadStatus = _ref.secretFileDownloadStatus,
      secretFileDownloadStatusCode = _ref.secretFileDownloadStatusCode,
      classes = _ref.classes,
      translatedStrings = _ref.translatedStrings,
      reloadSecretFile = _ref.reloadSecretFile,
      _ref$showDownloadButt = _ref.showDownloadButton,
      showDownloadButton = _ref$showDownloadButt === void 0 ? true : _ref$showDownloadButt;

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      showFile = _useState2[0],
      setShowFile = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      base64File = _useState4[0],
      setBase64File = _useState4[1];

  var downloadFileRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (file) {
      var fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = function () {
        return setBase64File(fileReader.result);
      };
    }
  }, [file]);
  return showFile ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.fieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", fileFieldName, " "), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.fieldValueWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.fileButtonsWrapper
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    variant: "primary",
    onClick: function onClick() {
      return setShowFile(!showFile);
    }
  }, translatedStrings.showButtonText), fileName && showDownloadButton && /*#__PURE__*/_react.default.createElement(_button.default, {
    variant: "secondary",
    onClick: function onClick() {
      return downloadFileRef.current && downloadFileRef.current.click();
    }
  }, translatedStrings.downloadFile, /*#__PURE__*/_react.default.createElement("a", {
    ref: downloadFileRef,
    style: {
      display: 'none'
    },
    href: base64File,
    download: fileName
  })))))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.fieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", fileFieldName, " "), !fileName && secretFileDownloadStatusCode === 400 && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.fieldValueWrapper
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, 'no file attached'))), fileName && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.fieldValueWrapper
  }, (0, _commonUtils.isLoading)(secretFileDownloadStatus) && /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: 'small',
    message: "Loading file ".concat(fileName, "...")
  }), (0, _commonUtils.isSuccess)(secretFileDownloadStatus) && file && /*#__PURE__*/_react.default.createElement(_fileViewer.default, {
    file: file
  }), (0, _commonUtils.isError)(secretFileDownloadStatus) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classes.fileLoadingError, " ").concat(classes.fieldSpacing)
  }, /*#__PURE__*/_react.default.createElement(_notification.default, {
    type: 'error',
    title: translatedStrings.secretDownloadFailedMessage,
    open: open,
    inPlace: true,
    position: 'left'
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.detailsActionButtonsContainer
  }, (0, _commonUtils.isError)(secretFileDownloadStatus) && /*#__PURE__*/_react.default.createElement(_button.default, {
    variant: "primary",
    className: classes.detailsActionButtonsContainer,
    onClick: function onClick() {
      return reloadSecretFile();
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _IoReload.default,
    alt: "reload file",
    style: {
      marginRight: '0.5rem'
    }
  }), "Reload"), !(0, _commonUtils.isLoading)(secretFileDownloadStatus) && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(classes.fieldValueWrapper, " ").concat(classes.btnMarginLeft)
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    variant: "primary",
    onClick: function onClick() {
      return setShowFile(!showFile);
    }
  }, translatedStrings.hideButtonText)))));
};

exports.FileViewerRenderer = FileViewerRenderer;
FileViewerRenderer.propTypes = {
  file: _propTypes.default.any,
  fileName: _propTypes.default.string,
  fileFieldName: _propTypes.default.string,
  secretFileDownloadStatus: _propTypes.default.string,
  secretFileDownloadStatusCode: _propTypes.default.string,
  classes: _propTypes.default.object,
  translatedStrings: _propTypes.default.object,
  showDownloadButton: _propTypes.default.bool,
  reloadSecretFile: _propTypes.default.func
};